exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HqsM_PCN4xkIPfgHXrKx4{max-width:600px!important}.-hACER1TBQE_FWvEG1ps8{display:inline-block}html[dir] ._32OEr5r9mLTnSZXrZB34z0,html[dir] .Tgp5kPMQc2PNjFpePsm5-{margin-top:10px}", ""]);

// exports
exports.locals = {
	"dialog": "HqsM_PCN4xkIPfgHXrKx4",
	"spinner": "-hACER1TBQE_FWvEG1ps8",
	"advanced": "Tgp5kPMQc2PNjFpePsm5-",
	"checkbox": "_32OEr5r9mLTnSZXrZB34z0"
};